import Group from '../../assets/htbd-images/Group.png';
import circle from '../../assets/htbd-images/circle.png';

function OurPolicy() {
  return (
      <section className="container-fluid p-5 text-center position-relative">
        <h1 className="text-white">
          Our <strong style={{ color: "#7e56d8" }}>Policies</strong>
        </h1>
        <div className="row justify-content-md-center g-5">
          <div className="col-lg-3">
            <div className="p-3 bg-light rounded-3 h-100">
              <h3>Anti-racism Policy</h3>
              <p>
                We are committed to controlling any type of racism or bullying
                during the class or any interaction with peers. An appropriate
                standard procedure is in place to report any such incident. In
                such a case, serious actions to debar the individuals from the
                qualification will be taken.
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-3 bg-light rounded-3 h-100">
              <h3>Appeal Policy</h3>
              <p>
                In case a student wishes to challenge an academic decision,
                please contact the program manager & demand the appeal form to
                submit it as per instruction provided by the program manager.
                The result of the appeal will be communicated to you through
                contact details.
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-3 bg-light rounded-3 h-100">
              <h3>Contingency And Adverse effect Policy</h3>
              <p>
                There is a plan in place to deal with any contingent or adverse
                situation. In any case of extenuating circumstances please feel
                free to reach the program manager through contact details and
                discuss a plan of action to deal with the relevant situation.
              </p>
            </div>
          </div>
        </div>
        <span className="position-absolute bottom-0 translate-middle-x" style={{ zIndex: -1, right:'5%' }}>
          <img src={Group} alt="Group" />
        </span>
        <span className="position-absolute top-0 translate-middle-x" style={{ zIndex: -1, left:'20%' }}>
          <img src={circle} alt="circle" />
        </span>
      </section>
  );
}

export default OurPolicy;
